import { number } from 'jquery';
import Swiper from 'swiper';
import SwiperCore from "swiper/core";
import { Navigation, Pagination } from 'swiper/modules';
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import * as basicLightbox from 'basiclightbox';

SwiperCore.use([Navigation, Pagination]);

@ModuleName("AxProdDetail")
export class AxProdDetail implements AxInit {
    private Swiper: Swiper;
    private Swiper2: Swiper;
    private SwiperModal: Swiper;

    AxInit(init: any): void {
        const observer = new IntersectionObserver(
            ([e]) => {
                e.target.toggleAttribute('stuck', e.intersectionRatio < 1)
            },
            { threshold: [1] }
        );
        let count: number = init.count;
        observer.observe(document.querySelector('.ax-pill_menu'));
        observer.observe(document.querySelector('.details__hero-price'));
        this.Swiper = new Swiper('.swiper1', {
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 'auto',               
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    }
                },
                120: {
                    spaceBetween: 0,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    }

                }
            }
        });
        if (count > 1) {
            this.Swiper2 = new Swiper('.swiper2', {
                //pagination: {
                //    el: ".swiper-pagination",
                //    clickable: true
                //},
                breakpoints: {
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        roundLengths: false,
                        loop: true,
                        loopAdditionalSlides: 20,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        }
                    },
                    120: {
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        loop: true,
                        loopAdditionalSlides: 5,
                        spaceBetween: 0
                    }
                }

            });
        } else {
            this.Swiper2 = new Swiper('.swiper2', {
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        roundLengths: false,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        }
                    },
                    120: {
                        spaceBetween: 0,
                    }
                }

            });
        }
        if (count > 1) {
            this.SwiperModal = new Swiper('.swiper-Modal', {
                breakpoints: {
                    700: {
                        spaceBetween: 20,
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        roundLengths: false,
                        loop: true,
                        loopAdditionalSlides: 20,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        }
                    },
                    120: {
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        loop: true,
                        loopAdditionalSlides: 5,
                        spaceBetween: 0,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        }
                    }
                }
            });
        } else {
            this.SwiperModal = new Swiper('.swiper-Modal', {
                breakpoints: {
                    700: {
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        roundLengths: false,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        }
                    },
                    120: {
                        spaceBetween: 0,
                    }
                }

            });
        }        
        let modalOpenBtn = $('.swiper-vid-expand-btn');
        modalOpenBtn.on('click', () => {
            $('.swiper-modal').attr('style', '');
        });
        let mediaPoint = window.matchMedia("(max-width: 768px)");
        mediaPoint.addListener(() => changeMediaPoint());
        changeMediaPoint();
        $(".ax-scroll-btn").on('click', () => { topFunction(); });
        window.onscroll = function () { scrollFunction() };
        setIndex();
        this.Swiper2.on('slideChangeTransitionEnd', () => {
            setIndex();
        });       
        function setIndex() {
            let contentCount = $('.content-count-span');
            let numb: number = +$('.swiper-slide-active').get(1).getAttribute('data-swiper-slide-index') + 1;
            contentCount.text(numb + '/' + count);
        }
        function changeMediaPoint() {
            let imageContainer = $('.imageContainer');
            let videoContainer = $('.videoContainer');
            let imageContainerModal = $('.imageContainer-modal');
            let videoContainerModal = $('.videoContainer-modal');
            let modal = $('.swiper-modal');
            let modalClose = $('.close-vid-modal');
            let modalExpand = $('.swiper-vid-expand-btn');
            let modalCount = $('.swiper-content-count');
            if (!window.matchMedia("(max-width: 768px)").matches) {
                modalClose.click((e) => { modal.attr('style', 'display:none;') });
                modalExpand.attr('style', 'display:none;');
                modalCount.attr('style', 'display:none;');
                modal.attr('style', 'display:none;');
                if (imageContainer.length > 0) {
                    imageContainer.each((i, e) => {
                        $(e).unbind('click');
                        $(e).click((e) => {
                            bslContent(e.currentTarget as HTMLElement);
                        });
                    });
                }
                if (videoContainer.length > 0) {
                    videoContainer.each((i, e) => {
                        $(e).unbind('click');
                        $(e).click((e) => {
                            bslContent(e.currentTarget as HTMLElement);
                        });
                    });
                }
            } else if (window.matchMedia("(max-width: 768px)").matches) {
                modalExpand.removeAttr('style');
                modalCount.removeAttr('style');
                modalClose.click((e) => { modal.attr('style', 'display:none;') });
                imageContainerModal.click(e => {
                    bslContentModal(e.currentTarget as HTMLElement);
                });
                videoContainerModal.click((e) => {
                    bslContentModal(e.currentTarget as HTMLElement);
                });

                if (imageContainer.length > 0) {
                    imageContainer.each((i, e) => {
                        $(e).unbind('click');
                        $(e).click((e) => {
                            modal.removeAttr('style');
                        });
                    });
                }
                if (videoContainer.length > 0) {
                    videoContainer.each((i, e) => {
                        $(e).unbind('click');
                        $(e).click((e) => {
                            modal.removeAttr('style');
                        });
                    });
                }
            }
        }
        function scrollFunction() {
            let scrollBtn = $(".ax-scroll-btn").get(0);
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                scrollBtn.style.display = "";
            } else {
                scrollBtn.style.display = "none";
            }
        }
        function topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        function bslContentModal(html: HTMLElement) {
            let outer = document.createElement('div');
            const btnClose = document.createElement('div');
            btnClose.setAttribute('class', 'close-vid-btn cursor');
            let ele: HTMLMediaElement;
            console.log(html);
            if (html.hasChildNodes && html.children[0] != null || html.children[0] != undefined) {
                ele = html.children[0] as HTMLMediaElement;
                html.appendChild(btnClose);
            }
            else {
                ele = html as HTMLMediaElement;
                html.appendChild(btnClose);
            }
            let clonedNode = null;
            outer.appendChild(html.cloneNode(true));           
            html.removeChild(btnClose);
            if (ele.tagName.toLowerCase() == 'video') {
                clonedNode = outer.querySelector('video') as HTMLVideoElement;
            }
            else {
                clonedNode = outer.querySelector('img') as HTMLImageElement;
            }           
            
            if (clonedNode.tagName.toLowerCase() == 'video') {
                if (clonedNode != null) {
                    clonedNode.classList.remove('vid-shadow');
                    clonedNode.setAttribute('autoplay', "");
                    clonedNode.setAttribute('muted', "");               
                }
            }
            clonedNode.setAttribute("style", "z-index:9999 !important;");
            const instance = basicLightbox.create(outer.innerHTML, {
                onShow: (instance) => {
                    $(document).keyup(function (e) {
                        if (e.key == "Escape") {
                            instance.close();
                        }
                    });
                    instance.element().querySelector('.close-vid-btn').onclick = () => instance.close();
                    if (ele.tagName.toLowerCase() == 'video') {
                        setupVidControlsModal(instance.element().querySelector('.videoContainer-modal'));
                    }
                },
                onClose: (instance) => {
                    if (clonedNode != null && clonedNode.tagName.toLowerCase() == 'video') {
                        clonedNode.pause();
                        clonedNode.remove();
                        btnClose.remove();
                    }
                    outer.remove();
                }
            });
            instance.show();
            const bslightbox = $('.basicLightbox');
            if (bslightbox != null) {
                bslightbox.attr('style', 'z-index:9000 !important;');           
            }
            if (clonedNode != null) {
                clonedNode.removeAttribute('autoplay');
                clonedNode.removeAttribute('controls');
                clonedNode.removeAttribute('style');
            }
        }
        function bslContent(html: HTMLElement) {
            let outer = document.createElement('div');
            const btnClose = document.createElement('div');
            btnClose.setAttribute('class', 'close-vid-btn cursor');
            let ele: HTMLElement;
            if ((html.hasChildNodes && html.children[0] != null || html.children[0] != undefined) && html.children[0].tagName.toLowerCase() == 'video') {
                ele = html.children[0] as HTMLMediaElement;
                html.appendChild(btnClose);              
            }
            else {
                ele = html.children[0] as HTMLElement;
                html.appendChild(btnClose);
            }
            let clonedNode= null;                   
            outer.appendChild(html.cloneNode(true));            
            html.removeChild(btnClose);
            if (ele.tagName.toLowerCase() == 'video') {
                clonedNode = outer.querySelector('video') as HTMLVideoElement;
            }
            else {               
                clonedNode = outer.querySelector('img') as HTMLElement;
            }    
            let figure = outer.querySelector('figure');
            figure.classList.remove('figure-swiper');          
            if (clonedNode.tagName.toLowerCase() == 'video') {
                if (clonedNode != null) {
                    clonedNode.classList.remove('vid-shadow');    
                    figure.classList.add('figure-swiper-lightbox-vid');
                    clonedNode.setAttribute('autoplay', "");
                    clonedNode.setAttribute('muted', "");
                    clonedNode.classList.remove('vid');
                    clonedNode.classList.add('vid-lightbox');
                    clonedNode.classList.add('vid-lightbox');
                }
            }
            if (clonedNode.tagName.toLowerCase() == 'img') {
                let imgEle = html.querySelector('img.img-vid') as HTMLElement;
                let styleUri = imgEle.style.backgroundImage;   
                figure.classList.add('figure-swiper-lightbox-img');
                clonedNode.classList.remove('img-vid');
                clonedNode.style.backgroundImage = styleUri;
            }
            clonedNode.style.zIndex = '9999 !important';
            const instance = basicLightbox.create(outer.innerHTML, {
                onShow: (instance) => {
                    $(document).keyup(function (e) {
                        if (e.key == "Escape") {
                            instance.close();
                        }
                    });
                    instance.element().querySelector('.close-vid-btn').onclick = () => instance.close();
                    if (ele.tagName.toLowerCase() == 'video') {
                        setupVidControls(instance.element().querySelector('.videoContainer'));
                    }
                },
                onClose: (instance) => {
                    if (clonedNode != null && clonedNode.tagName.toLowerCase() == 'video') {
                        clonedNode.pause();
                        clonedNode.remove();
                        btnClose.remove();
                    }
                    outer.remove();
                }
            });
            instance.show();
            const bslightbox = $('.basicLightbox');
            if (bslightbox != null) {
                bslightbox.attr('style', 'z-index:9000 !important;');
                const placeholder = $('.basicLightbox__placeholder');
                if (placeholder != null) {
                    placeholder.attr('style', ' max-width: 95% !important; transform: scale(.9)!important; ')
                }
            }
            if (clonedNode != null) {
                clonedNode.removeAttribute('autoplay');
                clonedNode.removeAttribute('controls');
                clonedNode.removeAttribute('style');
            }
        }
        function setupVidControlsModal(container: HTMLElement) {
            const video = container.querySelector(".vid-modal") as unknown as HTMLMediaElement;
            const playpauseVidBtn = container.querySelector(".playpause-vid-btn") as unknown as HTMLElement;
            playpauseVidBtn.setAttribute("style", "display:none;");
            video.controls = true;
            video.preload = 'metadata';
            video.addEventListener("touchstart", (e) => {
                if (video.paused || video.ended) {
                   
                    video.play();
                } else {
                   
                    video.pause();
                }
            });
        }
        function setupVidControls(container: HTMLElement) {
            const supportsVideo = !!document.createElement("video").canPlayType;
            if (supportsVideo) {
                const videoContainer = container as HTMLElement;
                videoContainer.removeAttribute("display");
                //const video = container.querySelector(".vid") as unknown as HTMLMediaElement;
                const video = container.querySelector(".vid-lightbox") as unknown as HTMLMediaElement;
                const videoControls = container.querySelector(".video-controls") as unknown as HTMLElement;
                const playpauseVidBtn = container.querySelector(".playpause-vid-btn") as unknown as HTMLElement;
                //videoControls.setAttribute("style", "display:none;");
                playpauseVidBtn.setAttribute("style", "display:none;");
                //video.controls = false;
                video.controls = true;
                video.preload = 'metadata';
                //videoControls.style.display = "flex";
                videoControls.style.display = "none";
                const playpause = container.querySelector(".playpause") as unknown as HTMLElement;
                playpause.setAttribute('data-state', 'pause');
                const stop = container.querySelector(".stop") as unknown as HTMLElement;
                const mute = container.querySelector(".mute") as unknown as HTMLElement;
                const volinc = container.querySelector(".volinc") as unknown as HTMLElement;
                const voldec = container.querySelector(".voldec") as unknown as HTMLElement;
                const progress = container.querySelector(".progress-id") as unknown as HTMLProgressElement;
                const progressBar = container.querySelector(".progress-bar") as unknown as HTMLElement;
                const fullscreen = container.querySelector(".fs") as unknown as HTMLElement;
                video.addEventListener("touchstart", (e) => {
                    if (video.paused || video.ended) {
                        playpause.setAttribute('data-state', 'pause');
                        video.play();
                    } else {
                        playpause.setAttribute('data-state', 'play');
                        video.pause();
                    }
                });
                playpause.addEventListener("click", (e) => {
                    if (video.paused || video.ended) {
                        playpause.setAttribute('data-state', 'pause');
                        video.play();
                    } else {
                        playpause.setAttribute('data-state', 'play');
                        video.pause();
                    }
                });
                stop.addEventListener("click", (e) => {
                    video.pause();
                    //video.currentTime = 0;
                    //progress.value = 0;
                });
                mute.addEventListener("click", (e) => {
                    video.muted = !video.muted;
                });
                volinc.addEventListener("click", (e) => {
                    alterVolume("+", video, videoContainer);
                });
                voldec.addEventListener("click", (e) => {
                    alterVolume("-", video, videoContainer);
                });

                video.addEventListener("loadedmetadata", () => {
                    progress.setAttribute("max", video.duration.toString());
                });
                video.addEventListener("timeupdate", () => {
                    progress.value = video.currentTime;
                    progressBar.style.width = `${Math.floor(
                        (video.currentTime * 100) / video.duration
                    )}%`;
                });
                video.addEventListener("timeupdate", () => {
                    if (!progress.getAttribute("max"))
                        progress.setAttribute("max", video.duration.toString());
                    progress.value = video.currentTime;
                    progressBar.style.width = `${Math.floor(
                        (video.currentTime * 100) / video.duration
                    )}%`;
                });
                progress.addEventListener("click", (e) => {
                    const rect = progress.getBoundingClientRect();
                    const pos = (e.pageX - rect.left) / progress.offsetWidth;
                    video.currentTime = pos * video.duration;
                });
                if (!document?.fullscreenEnabled) {
                    fullscreen.style.display = "none";
                }
                fullscreen.addEventListener("click", (e) => {
                    handleFullscreen(videoContainer);
                });
            }
        }
        function alterVolume(dir: string, video: HTMLMediaElement, videoContainer: HTMLElement) {
            const currentVolume = Math.floor(video.volume * 10) / 10;
            if (dir === "+" && currentVolume < 1) {
                video.volume += 0.1;
            } else if (dir === "-" && currentVolume > 0) {
                video.volume -= 0.1;
            }
            document.addEventListener("fullscreenchange", (e) => {
                setFullscreenData(!!document.fullscreenElement, videoContainer);
            });
        }
        function handleFullscreen(videoContainer: HTMLElement) {
            if (document.fullscreenElement !== null) {
                document.exitFullscreen();
                setFullscreenData(false, videoContainer);
            } else {
                videoContainer.requestFullscreen();
                setFullscreenData(true, videoContainer);
            }
        }
        function setFullscreenData(state: boolean, videoContainer: HTMLElement) {
            let stateString = state.toString()
            videoContainer.setAttribute("data-fullscreen", stateString);
        }
    }
}
